import { CardConfig, SelectorConfig, TableConfig } from '../models/ui-config.models';

export const MANAGER_TABLE_COLUMNS: TableConfig[] = [
  { key: 'name', title: '__CALLS_LEARNER__', renderType: 'text', size: 2 },
  { key: 'scenarioCompleted', title: '__CALLS_SCENARIO_COMPLETED__', renderType: 'progress', size: 2.7, format: '/', progressKeys: { completed: 'scenarioCompleted', total: 'scenarioCount', percent: 'scenarioCompletedPercent'} },
  { key: 'avgScore', title: '__CALLS_AVG_SCORE_SHORT__', renderType: 'text', size: 1.5, format: '1.2-2', unit: '%' },
  { key: 'bestScore', title: '__CALLS_AVG_BEST_SCORE_SHORT__', renderType: 'text', size: 1.5, format: '1.2-2', unit: '%' },
  { key: 'timeToMasteryText', title: '__CALLS_TIME_TO_MASTERY__', renderType: 'text', size: 2 },
  { key: 'improvementText', title: '__CALLS_IMPROVEMENT__', renderType: 'chip', size: 2 },
];

export const MANAGER_CARDS: CardConfig[] = [
  {
    key: 'completedPercent',
    title: 'Completed',
    format: '1.2-2',
    unit: '%',
    iconPath: '/assets/icon/green-mark.svg',
    iconAlt: 'green-mark'
  },
  {
    key: 'score',
    title: 'Average Score',
    format: '1.2-2',
    unit: '%',
    iconPath: '/assets/icon/chart-mark.svg',
    iconAlt: 'chart-mark'
  },
  {
    key: 'bestScore',
    title: 'Best Score',
    format: '1.2-2',
    unit: '%',
    iconPath: '/assets/icon/sun-badge.svg',
    iconAlt: 'sun-badge'
  },
  {
    key: 'timeToMastery',
    title: 'Avg. Time to Mastery',
    format: '1.0-0',
    unit: ' mins',
    iconPath: '/assets/icon/clock-mark.svg',
    iconAlt: 'clock-mark'
  },
  {
    key: 'improvement',
    title: 'Improvement',
    format: '1.2-2',
    unit: '%',
    iconPath: '/assets/icon/chart-growth.svg',
    iconAlt: 'chart-growth'
  }
];

export const ALL_SCENARIO_ID = -1;
export const ALL_SCENARIOS: { title: string; value: number } = { title: 'All Scenarios', value: ALL_SCENARIO_ID };
export const MY_TEAM: { title: string; value: string } = { title: '(My Team)', value: '' };
export const LEARNER: { title: string; value: string } = { title: 'All Learners', value: '' };
export const SELECTOR_CONFIGS: SelectorConfig[] = [
  {key: 'scenarios', type: 'multi', value: [ALL_SCENARIO_ID], prevValue: [ALL_SCENARIO_ID], baseValue: ALL_SCENARIO_ID, options: [], closeOnSelect: false },
  {key: 'manager', type: 'single', value: '', options: [], closeOnSelect: true },
  {key: 'learner', type: 'multi', value: [''], prevValue: [''], baseValue: '', options: [], closeOnSelect: false },
];

